<script setup lang="ts">
import { computed } from 'vue';
import { legalSteps } from '@/utils/config/constants';

const props = defineProps<{
  legalStepName: string;
}>()

const legalStepColor = computed(() => legalSteps[props.legalStepName].color)
</script>
<template>
    <div :class="`flex-none rounded-full bg-${legalStepColor}-500/20 p-1`">
      <div :class="`h-1.5 w-1.5 rounded-full bg-${legalStepColor}-500`" />
    </div>
</template>